<template>
	<a-modal :title="isUpdate ? '修改职业' : '新增职业'" :width="640" :visible="visible" :confirmLoading="false"
		:maskClosable="false" @ok="handleOk" @cancel="handleCancel">
		<a-spin :spinning="loading">
			<a-form-model ref="adminForm" :model="form" :label-col="{span:6}" :wrapper-col="{span:14}" autoComplete="off">
				<a-form-model-item v-show="false" label="ID" prop="id">
					<a-input type="hidden" v-model.number="form.id" />
				</a-form-model-item>

				<a-form-model-item label="选择上级" prop="pid"
					:rules="[{ required: true, message: '必选，不能为空', trigger: 'change' }]">
					<a-select v-model="form.pid" style="width:100px" placeholder="请选择">
						<a-select-option value="0">无</a-select-option>
						<a-select-option v-for="profession in professionTopList" :value="String(profession.id)"
							:key="profession.id">
							{{ profession.workName }}
						</a-select-option>
					</a-select>
				</a-form-model-item>

				<a-form-model-item label="职业名称" prop="workName"
					:rules="[
						{ required: true, message: '必填，不能为空', trigger: 'blur' },
						{ validator: isExistWorktName, trigger: 'blur' }
					]">
					<a-input v-model="form.workName" style="width:200px" />
				</a-form-model-item>
			</a-form-model>
		</a-spin>
	</a-modal>
</template>

<script>
	import pick from 'lodash.pick';
	import {
		workNameIsExist,
		professionTopList
	} from '@/api/system/profession';

	const fields = ['id', 'workName'];

	function emptyForm() {
		return {
			id: 0,
			pid: '0',
			workName: ''
		};
	}

	export default {
		props: {
			visible: {
				type: Boolean,
				required: true
			},
			loading: {
				type: Boolean,
				default: () => false
			},
			model: {
				type: Object,
				default: () => null
			}
		},
		data() {
			return {
				form: emptyForm(),
				professionTopList: [],
			}
		},
		created() {
			this.getProfessionTopList();

			this.unwatch = this.$watch('model', (newVal) => {
				if (!newVal) {
					this.initForm();
					return;
				}

				let pid = '0';
				if (newVal.pid !== undefined && newVal.pid !== null && Number(newVal.pid) > 0) {
					pid = String(newVal.pid);
				}

				this.$nextTick(() => {
					const base = pick(newVal, fields);
					this.form = { ...emptyForm(), ...base, pid };
					if (this.$refs.adminForm) {
						this.$refs.adminForm.clearValidate();
					}
				});
			}, {
				immediate: true
			});
		},
		computed: {
			isUpdate: function() {
				return this.model && this.model.id > 0 ? true : false;
			},
		},
		watch: {
			visible(newVal) {
				if (newVal) {
					this.getProfessionTopList();
				}
			}
		},
		methods: {
			getProfessionTopList() {
				professionTopList().then(res => {
					this.professionTopList = res.data.recordList;
				});
			},
			initForm() {
				this.form = emptyForm();
				this.$nextTick(() => {
					if (this.$refs.adminForm) {
						this.$refs.adminForm.clearValidate();
					}
				});
			},
			handleOk() {
				this.$emit('ok');
			},
			handleCancel() {
				this.$emit('cancel');
				this.resetState();
			},
			resetState() {

			},
			isExistWorktName(rule, value, callback) {
				if (value === undefined || value === '' || (this.model && this.model.workName === value)) {
					callback();
					return;
				}
				workNameIsExist(value).then(res => {
					if (res.data) {
						callback(new Error('职业已存在'));
					} else {
						callback();
					}
				}).catch(() => {
					callback();
				});
			},
		}
	}
</script>

<style scoped>
	.ant-input-number-handler-wrap :deep(.ant-input-number-handler-wrap) {
		display: none;
	}
</style>
